module.exports = __webpack_public_path__ + "page-infinie.jpg?be24559dc791206704c37544e418d6e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/page-infinie.jpg
// module id = 77
// module chunks = 0